import { ApiSchemas } from '..'
import { operations } from '../api'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async getById(id: number) {
    return wrapEndpoint(() =>
      client.GET('/uploaded-file/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async list(options?: operations['UploadedFileController_list']['parameters']['query']) {
    return wrapEndpoint(() =>
      client.GET('/uploaded-file', {
        params: {
          query: options,
        },
      }),
    )
  },
  async create(body: ApiSchemas['CreateUploadedFileDto']) {
    return wrapEndpoint(() =>
      client.POST('/uploaded-file', {
        body,
        bodySerializer(body) {
          const fd = new FormData()

          fd.append('type', body.type)
          fd.append('name', body.name)

          if (body.description) fd.append('description', body.description)
          if (body.referenceDate) fd.append('referenceDate', body.referenceDate)
          if (body.physicianId !== undefined) fd.append('physicianId', String(body.physicianId))
          if (body.attendanceId !== undefined) fd.append('attendanceId', String(body.attendanceId))
          if (body.patientId !== undefined) fd.append('patientId', String(body.patientId))
          if (body.treatmentId !== undefined) fd.append('treatmentId', String(body.treatmentId))
          fd.append('file', body.file as unknown as File)
          fd.append('isPublic', String(body.isPublic))
          return fd
        },
      }),
    )
  },
  async delete(id: number) {
    return wrapEndpoint(() =>
      client.DELETE('/uploaded-file/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
